











import Vue from 'vue'
import RoundButton from '@/components/atoms/RoundButton.vue'
import { nl2br } from '@/utils'

export default Vue.extend({
  name: 'PointGet',
  components: {
    RoundButton
  },
  props: {
    pointText: {
      type: String,
      required: true,
      default: ''
    },
    abstract: {
      type: String,
      required: false,
      default: ''
    },
    buttonText: {
      type: String,
      required: true,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    },
    nl2br(text: string) {
      return nl2br(text)
    }
  }
})
